<template>
  <div class="pageTop">
    <van-cell>
      <template #title>
        <span>预约单号：</span>
        <span>{{userInfo.orderCode}}</span>
      </template>
    </van-cell>
    <van-cell>
      <template #title>
        <span>预约时间：</span>
        <span>{{userInfo.orderDate}}</span>
      </template>
    </van-cell>
    <van-cell>
      <template #title>
        <span>用户姓名：</span>
        <span>{{userInfo.userName}}</span>
      </template>
    </van-cell>
    <van-cell>
      <template #title>
        <span>联系电话：</span>
        <span class="tel">{{userInfo.phoneNumber}}</span>
      </template>
    </van-cell>
    <van-cell>
      <template #title>
        <span>详细地址：</span>
        <span>{{userInfo.address}}</span>
      </template>
    </van-cell>
    <van-cell v-if="userInfo.serviceType==1">
      <template #title>
        <span>预估面积：</span>
        <span>{{userInfo.estimatedArea}} ㎡</span>
      </template>
    </van-cell>
    <van-cell v-if="userInfo.serviceType==2">
      <template #title>
        <span>机器型号：</span>
        <span>{{userInfo.machineType}} ㎡</span>
      </template>
    </van-cell>
    <van-cell>
      <template #title>
        <span>{{userInfo.serviceType==2?'故障描述':'备注'}}：</span>
        <span>{{userInfo.orderRemark}}</span>
      </template>
    </van-cell>
  </div>
</template>

<script>
export default {
  name: 'pageTop',
  data () {
    return {
      msg: 'Welcome to Your Vue.js App'
    }
  },
  props:{
    userInfo:{
      type:Object,
      userInfo:() => {
        return {
          orderCode:'',
          orderDate:'',
          userName:'',
          phoneNumber:'',
          address:'',
          estimatedArea:'',
          orderRemark:''
        }
      },
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.pageTop{
  .van-cell__title{
    span{
      font-size: 14px;
      color:#000000;
      &:first-child{
        font-size: 15px;
        color:#000000;
        font-weight: bold;
      }
    }
    .tel{
      color: #65A1FF;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pageTop.vue